<template>
  <transition name="mask">
    <div class="modal-mask" v-if="visible" @click.self="() => hideModal()">
      <div
        class="modal-wrapper"
        :style="{ 'border-color': border_color }"
      >
        <div class="decorate" v-if="showDecorate">
          <img :src="img_url" alt="" />
        </div>
        <h3 class="title">{{ title }}</h3>
        <div class="btn-close" v-if="showCloseBtn" @click="hideModal">
          <HbIcon common-close/>
        </div>
        <div class="modal-content-scroll" v-if="scroll">
          <div class="scroll-content">
            <slot name="scroll"></slot>
          </div>
        </div>
        <div class="modal-content" v-else>
          <slot></slot>
        </div>
        <div class="modal-footer" v-if="footer">
          <p>{{ footer }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    footer: {
      type: String,
      default: ''
    },
    scroll: {
      type: Boolean,
      default: false
    },
    border_color: {
      type: String,
      default: ''
    },
    showDecorate: {
      type: Boolean,
      default: false
    },
    img_url: {
      type: String,
      default: 'https://cdn.max-c.com/heybox/dailynews/img/a1175c46a618dfda5d0384e4f2703baa.png'
    },
    over_close: {
      type: Boolean,
      default: true
    },
    showCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    showModal () {
      this.visible = true
      this._top = document.scrollingElement.scrollTop
      document.body.classList.add('body-fixed')
      document.body.style.top = -this._top + 'px'
    },
    hideModal (force = false, keep_fixed = false) {
      // console.log(this.over_close, force);
      if (!this.over_close && !force) return
      this.visible = false
      if (!keep_fixed) {
        document.body.classList.remove('body-fixed')
        document.scrollingElement.scrollTop = this._top
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="less">
.modal-mask {
  background-color: rgba(0, 0, 0, 0.8);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transform: translate3d(0, 0, 0);
  .modal-wrapper {
    background: linear-gradient(146.79deg, #FFE8D9 -4.05%, #FEDDC1 19.89%, #FFF7E7 53.01%, #FFCEA8 97.84%);
    border-radius: 10px;
    border: 2px solid;
    left: 50%;
    max-height: 349px;
    padding: 16px 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 315px;
    .decorate {
      height: 79px;
      left: -11px;
      position: absolute;
      top: -65px;
      width: 337px;
      img {
        display: block;
        height: 100%;
        width: 100%;
      }
    }
    .modal-footer {
      height: 36px;
      margin-top: 16px;
      overflow: hidden;
      position: relative;
      width: 100%;
      &:after {
        background-color: #2d2c3a;
        content: '';
        height: 1px;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }
      p {
        color: rgba(255, 255, 255, 0.4);
        font-size: 12px;
        height: 16px;
        line-height: 16px;
        margin-top: 20px;
        text-align: center;
      }
    }
    .modal-content {
      margin-top: 16px;
      max-height: 256px;
      padding: 0 16px;
      width: 100%;
    }
    .modal-content-scroll {
      height: 228px;
      margin-top: 16px;
      padding: 0 16px;
      width: 100%;
      .scroll-content {
        -webkit-overflow-scrolling: touch;
        height: 100%;
        overflow-y: scroll;
        width: 100%;
      }
    }
    .title {
      color: #DE022C;
      font-size: 18px;
      font-weight: 500;
      height: 100%;
      line-height: 24px;
      text-align: center;
      width: 100%;
    }
    .btn-close {
      position: absolute;
      right: 12px;
      top: 15px;
      font-size: 18px;
      color: #B19B9F;
    }
  }
}
.mask-enter-active,
.mask-leave-active {
  transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
}
.mask-enter,
.mask-leave-to {
  opacity: 0;
}
.mask-enter-to,
.mask-leave {
  opacity: 1;
}
</style>
